import { SimpleGrid } from '@chakra-ui/react';
import { Section } from '../layout/Section';
import { CaseStudyCard } from './CaseStudyCard';
import { caseStudies } from '../../data/caseStudies';

export const CaseStudyGrid = () => {
  return (
    <Section
      id="case-studies"
      title="Case Studies"
      subtitle="Real projects, real results — see how we've helped organizations transform their operations"
    >
      <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={6}>
        {caseStudies.map((caseStudy, index) => (
          <CaseStudyCard
            key={caseStudy.id}
            caseStudy={caseStudy}
            index={index}
          />
        ))}
      </SimpleGrid>
    </Section>
  );
};
